<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
        <div class="col-md-12 mainheader mainheader header-container">
            <h5>Salesman</h5>
        </div>
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
        <!-- card -->
        <div class=" card ">
            <div class="card-body">
                <!-- bootstrap tabs -->
                <div class="kliqtab">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs p-0 mb-3">
                        <li class="nav-item"><a class="nav-link active" data-toggle="tab"
                                href="#salesmanCreation">Salesman Creation</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#targets">Targets &amp;
                                Incentives</a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane in active p-3" id="salesmanCreation">
                            <!-- salesmanCreation -->
                            <div class="row">
                                <!-- col -->
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-9">
                                    <!--/ row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Salesman Type</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select Salesman Type</option>
                                                    <option>Customer</option>
                                                    <option>Type Customer</option>
                                                    <option>Vendor</option>
                                                    <option>Relish</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Salesman Name</label>
                                                <input type="text" class="form-control" placeholder="Salesman Name">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Salesman Code</label>
                                                <input type="text" class="form-control" placeholder="Salesman Code">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Designation</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select Designation</option>
                                                    <option>Customer</option>
                                                    <option>Type Customer</option>
                                                    <option>Vendor</option>
                                                    <option>Relish</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Date of Birth</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i
                                                                class="zmdi zmdi-calendar"></i></span>
                                                    </div>
                                                    <input type="text" class="form-control datepicker"
                                                        placeholder="Date of Birth...">
                                                </div>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-6 col-md-8 col-sm-6">
                                            <div class="form-group">
                                                <label>Salesman Under</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select Salesman Under</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-12 col-md-12">
                                            <div class="form-group">
                                                <label>Address 1</label>
                                                <input type="text" class="form-control" placeholder="Address 1">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-12 col-md-12">
                                            <div class="form-group">
                                                <label>Address 2</label>
                                                <input type="text" class="form-control" placeholder="Address 2">
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ row -->
                                </div>
                                <!--/ col -->
                                <div class="col-md-3">
                                    <!-- buttons -->
                                    <div class="d-grid gap-2 d-md-block text-center">
                                        <button class="btn btn-secondary disabled rounded-pill"
                                            type="button">Active</button>
                                        <button class="btn btn-primary redbtn rounded-pill" type="button">Block</button>
                                    </div>
                                    <!--/ buttons -->
                                    <figure class="avatarImg text-center">
                                        <img src="./assets/images/avatar1.jpg" class="rounded-circle"
                                            alt="Profile Image">
                                    </figure>
                                    <!-- buttons -->
                                    <div class="d-grid gap-2 d-md-block text-center">
                                        <button class="btn btn-outline-primary redbtn rounded-pill" type="button">Web
                                            Cam</button>
                                        <button class="btn btn-outline-primary redbtn rounded-pill" type="button">Select
                                            Image</button>
                                    </div>
                                    <!--/ buttons -->
                                </div>
                            </div>
                            <div class="row">
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Area / Town</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select Area / Town</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>District</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select District</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>State</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select State</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>PIN Code</label>
                                        <input type="text" class="form-control" placeholder="PIN Code">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Country</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select Country</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Mobile</label>
                                        <input type="text" class="form-control" placeholder="Mobile">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Phone</label>
                                        <input type="text" class="form-control" placeholder="Phone">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="text" class="form-control" placeholder="Email">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-6 col-md-8 col-sm-6">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Pay Scale type</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>P</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6">
                                            <div class="form-group">
                                                <label>Pay Scale</label>
                                                <input type="text" class="form-control" placeholder="Pay Scale">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-6 col-md-8 col-sm-6">
                                    <div class="form-group">
                                        <label>Accountant Name</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select Accountant Name</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <br>
                                <div class="col-lg-12 col-md-12 ">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h5>Select Branch</h5>
                                        </div>
                                        <div class=" col-lg-3 col-md-3 col-sm-4 checkbox ">
                                            <div class="form-group">
                                                <input id="active1" type="checkbox">
                                                <label for="active1"> ALL</label>
                                            </div>
                                        </div>
                                        <div class=" col-lg-3 col-md-3 col-sm-4 checkbox ">
                                            <div class="form-group">
                                                <input id="active1" type="checkbox">
                                                <label for="active1"> Main Office </label>
                                            </div>
                                        </div>
                                        <div class=" col-lg-3 col-md-3 col-sm-4 checkbox ">
                                            <div class="form-group">
                                                <input id="active1" type="checkbox">
                                                <label for="active1"> Head Office</label>
                                            </div>
                                        </div>
                                        <div class=" col-lg-3 col-md-3 col-sm-4 checkbox ">
                                            <div class="form-group">
                                                <input id="active1" type="checkbox">
                                                <label for="active1"> Road Branch </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ salesmanCreation -->
                        </div>
                        <div role="tabpanel" class="tab-pane p-3" id="targets">
                            <!-- Incentives -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">April</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">May</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">June</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">July</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">August</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">September</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">November</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">December</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">january</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">february</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-2 text-right pt-4">March</div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Targets (INR)</label>
                                        <input type="text" class="form-control text-right" placeholder="0.00">
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Incentives (%)</label>
                                        <input type="text" class="form-control text-right" placeholder="0">
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!--/ Incentives -->
                        </div>
                    </div>
                </div>
                <!--/ bootstrap tabs -->
            </div>
            <div class="card-footer text-left w-100">
                
                <button class="btn redbtn" type="button">Another</button>
                <button class="btn redbtn" type="button">F3-Save</button>
                
                <button class="btn redbtn" type="button">clear</button>
                <button class="btn redbtn"    type="button">Cancel</button>
                <button class="btn redbtn" type="button">Help</button>
            </div>
        </div>
        <!--/ card -->
    </main>
    <!-- main body -->
</div>